import Vue from 'vue';
import VueRouter from 'vue-router';
import Embed from '@/views/Embed.vue';
import Live from '@/views/Live.vue';
import Showcase from '@/views/Showcase.vue';
import NoCookies from '@/views/NoCookies.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    //name: "Embed",
    component: Embed
  },
  {
    path: '/live',
    name: 'Live',
    component: Live
  },
  {
    path: '/embed',
    name: 'Embed',
    component: Embed
  },
  {
    path: '/showcase',
    name: 'Showcase',
    component: Showcase
  },
  {
    path: '/no-cookies',
    name: 'NoCookies',
    component: NoCookies
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASEPATH,
  routes
});
export default router;
